<template>
    <div id="data-list-list-view" class="data-list-container">
        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <vx-card class="overflow-hidden">
                    <div slot="no-body">
                        <div class="p-6 flex justify-between flex-row-reverse items-center">
                            <feather-icon
                                    icon="FileTextIcon"
                                    style="background: #e3f7ea"
                                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"/>
                            <div class="truncate">
                                <h2 class="mb-1 font-bold">{{ total }}</h2>
                                <span>Factures chargées</span>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <vx-card class="overflow-hidden">
                    <div slot="no-body">
                        <div class="p-6 flex justify-between flex-row-reverse items-center">
                            <feather-icon
                                    icon="DollarSignIcon"
                                    style="background: #fff1e5"
                                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning"/>
                            <div class="truncate">
                                <h2 class="mb-1 font-bold">{{ amount }}</h2>
                                <span>de Total</span>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <vx-card class="overflow-hidden">
                    <div slot="no-body">
                        <div class="p-6 flex justify-between flex-row-reverse items-center">
                            <feather-icon
                                    icon="FileTextIcon"
                                    style="background: #e3f7ea"
                                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"/>
                            <div class="truncate">
                                <h2 class="mb-1 font-bold">
                                    {{ success }}
                                </h2>
                                <span>Lignes valides</span>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <vx-card class="overflow-hidden">
                    <div slot="no-body">
                        <div class="p-6 flex justify-between flex-row-reverse items-center">
                            <feather-icon
                                    icon="FileTextIcon"
                                    style="background: #fce6e7"
                                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger"/>
                            <div class="truncate">
                                <h2 class="mb-1 font-bold">
                                    {{ error }}
                                </h2>
                                <span>Lignes invalides</span>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>

        </div>

        <div class="vx-row mt-10">
            <div class="vx-col  w-full">
                <vx-card title="Factures chargées">
                    <invoice-detail
                            :isSidebarActive="showSidebar"
                            @closeSidebar="toggleDataSidebar"
                            :data="sidebarData"
                            :showActions="false"
                    />
                    <vs-table
                            ref="table"
                            pagination
                            :max-items="itemsPerPage"
                            search
                            :data="upload_details"
                    >
                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-end">
                            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                                <vs-dropdown-menu>
                                    <vs-dropdown-item @click="itemsPerPage = 4">
                                        <span>4</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPage = 10">
                                        <span>10</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPage = 15">
                                        <span>15</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPage = 20">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                        <template slot="thead">
                            <vs-th sort-key="invoice">Facture</vs-th>
                            <vs-th sort-key="amount_ttc">Montant TTC</vs-th>
                            <vs-th sort-key="status">Etat</vs-th>
                            <vs-th sort-key="echeance">Echéance</vs-th>
                            <vs-th>Action</vs-th>
                        </template>

                        <template slot-scope="{ data }">
                            <tbody>
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    <span>{{ tr.reference }}</span>
                                </vs-td>
                                <vs-td>
                                    <span class="font-semibold">{{ tr.amount_ttc}} F CFA</span>
                                </vs-td>
                                <vs-td>
                                    <vs-chip :color="tr.error && tr.error.length == 0 ? 'success' : 'danger'">
                                        {{ tr.error && tr.error.length == 0 ? 'Valide' : 'Invalide' }}
                                    </vs-chip>
                                </vs-td>
                                <vs-td>
                                    <span>{{ tr.date_echeance}}</span>
                                </vs-td>
                                <vs-td class="whitespace-no-wrap">
                                    <template v-if="tr.error && tr.error.length != 0">
                                        <div class="flex">
                                            <vx-tooltip text="Détails">
                                                <feather-icon
                                                        icon="EyeIcon"
                                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                        class="mr-2"
                                                        @click="showDetails(tr)"
                                                />
                                            </vx-tooltip>
                                        </div>
                                    </template>
                                </vs-td>
                            </vs-tr>
                            </tbody>
                        </template>
                    </vs-table>

                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="mt-8 flex flex-wrap items-center justify-end">
                                <vs-button v-if="upload_details.length > 0" @click="validateUpload()" class="mr-2">Valider</vs-button>
                                <vs-button v-if="upload_details.length > 0" class="" @click="deleteUpload()" type="border" color="danger">Annuler</vs-button>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    import InvoiceDetail from "../InvoiceDetail";

    export default {
        components: {InvoiceDetail},
        data() {
            return {
                itemsPerPage: 8,
                isMounted: false,
                showSidebar: false,
                sidebarData: {},
                upload_details: [],
                total: 0,
                amount: 0,
                error: 0,
                success: 0,
                validate: false
            }
        },
        computed: {
            isAdmin() {
                return this.$store.state.AppActiveUser.userRole !== 'client'
            },
        },

        beforeRouteLeave(to, from, next) {
            if (!this.validate){
                if(confirm('voulez vous vraiement quitter ?')){
                let id = this.$route.params.id
                this.$vs.loading()
                this.$http.post('/bills/upload/delete/'+id).then(() => {
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            }
            }
            next()
        },

        mounted() {
            this.isMounted = true;
            this.getResultDetails();
        },
        methods: {
            toggleDataSidebar(val = false) {
                this.showSidebar = val;
            },
            showDetails(data) {
                this.sidebarData = { ...data.error };
                this.toggleDataSidebar(true);
            },
            getResultDetails(){
                let id = this.$route.params.id
                this.$vs.loading()
                this.$http.get('/bills/upload/detail/'+id).then((response) => {
                    let data = response.data
                    let element = data.el
                    this.error = element.error ? element.error : 0
                    this.success = element.success ? element.success : 0
                    this.upload_details = element.content ? element.content : []
                    this.total = data.total ? data.total : 0
                    this.amount = data.amount ? data.amount : 0
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },
            deleteUpload() {
                if (confirm('Voulez vous annuler l\'opération ?')){
                    this.validate = true
                    let id = this.$route.params.id
                    this.$vs.loading()
                    this.$http.post('/bills/upload/delete/'+id).then((response) => {
                        if (response.data.status){
                            window.GETCCMT.notification('success','Annulation','Opération effectuée');
                            this.$router.push('/uploads/invoices')
                        }
                        this.$vs.loading.close()
                    }).catch((error) =>{
                        this.$vs.loading.close()
                        if (error.response.status === 401){
                            this.$router.push('/login')
                        }
                    })
                }
            },

            validateUpload() {
                if (confirm('Voulez vous valider l\'opération ?')){
                    let id = this.$route.params.id
                    this.validate = true
                    this.$vs.loading()
                    this.$http.post('/bills/upload/validate/'+id).then((response) => {
                        if (response.data.status){
                            window.GETCCMT.notification('success','Validation','Opération effectuée');
                            this.$router.push('/uploads/invoices')
                        }
                        this.$vs.loading.close()
                    }).catch((error) =>{
                        this.$vs.loading.close()
                        if (error.response.status === 401){
                            this.$router.push('/login')
                        }
                    })
                }
            }
        },
    }
</script>